import { styled } from "@mui/material/styles";

export const VisitLayout = styled("div")(() => ({
  "& .visitStatus": {
    background: "rgba(19, 232, 0, 0.09)",
    color: " #0A7900",
    fontSize: "12px",
    fontWeight: "500",
    height: "38px",
    alignItems: "center",
    width: "100px",
    margin: "0px 10px",
    display: "grid",
    placeItems: "center",
    borderRadius: "0.2rem",
  },
  "& .Detail": {
    backgroundColor: "#EAF6FF",
    borderRadius: "10px",
    padding: " 12px",
    margin: "10px",
  },
  "& .TemporarilyDate": {
    display: "flex",
    justifyContent: "space-between",
    width: "200px",
    padding: " 12px",
  },
  "& .required": {
    fontSize: "14px",
    fontWeight: "500",
    color: "#3E73A4",
    padding: "0px 3px 0px 33px",
    width: " 500px",
  },
  "& .startingDate ": {
    display: "flex",
  },

  "& .dataAppend": {
    border: "1px solid #ccc",
    margin: "12px 5px",
    borderRadius: "10px",
    padding: "9px 9px",
  },
  "& .dateTime": {
    fontSize: "12px",
    fontWeight: "400",
    color: "#1F4970",
  },
  "& .dayData": {
    fontSize: "14px",
    color: "#1F4970",
    display: "block",
    margin: "3px",
    textTransform: "capitalize",
  },
  "& .Add-medication": {
    position: "absolute !important",
    top: "50% !important",
    zIndex: "9999",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    maxHeight: "90vh",
    width: "calc(100vw - 32px) !important",
    maxWidth: "782px",
    boxSizing: "border-box",
    margin: "0px",
    backgroundColor: "white!important",
    borderRadius: "12px!important",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 8px 10px -5px, rgba(0, 0, 0, 0.14) 0px 16px 24px 2px, rgba(0, 0, 0, 0.12) 0px 6px 30px 5px!important",
    padding: "18px",
    overflow: "auto",
    overflowX: "hidden",
  },
  "& .deleteIcon": {
    cursor: "pointer",
  },
  "& .stock": {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1F4970",
    display: " flex",
    alignItems: "center",
    gap: "5px",
  },
  "& .port": {
    borderRadius: "5px",
    fontSize: "12px",
    fontWeight: "400",
    p: {
      margin: 0,
      padding: 0,
    },
  },
}));
export default VisitLayout;
